function observeMutations(elementSelector, callback) {
  if (document.querySelectorAll(elementSelector).length == 0) {
    return;
  }
  var observer = new MutationObserver(callback);
  var config = { attributes: true, childList: true, characterData: true };
  observer.observe(document.querySelector(elementSelector), config);

  return observer;
}  

function enableSoldoutVariants() {
  if (!document.querySelectorAll('[data-product-options-container] select').length) {
    return;
  }
  
  //debugger;
  
  $('[data-product-options-container] select').find('option[disabled]').prop('disabled', false);
  
  $(document).on('change', '[data-product-options-container] select', function(e) {
    $('[data-product-options-container] select').find('option[disabled]').prop('disabled', false);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  console.log('READY');
  setTimeout(enableSoldoutVariants, 3000);
  
  observeMutations('[data-product-form]', function(m) {
    //console.log(m);
    enableSoldoutVariants();
  });
});